import { useState } from "react";
import { ArrowLeft, ArrowRight, ImagePlus, Loader2, Star, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { ADMIN_API, errText, img } from "@/components/listings/common";

export function PhotoManager({ lid, photos, onChange, locked, api = ADMIN_API }) {
  const [progress, setProgress] = useState(null);
  const upload = async (e) => {
    const list = [...e.target.files]; e.target.value = "";
    if (!list.length) return;
    let current = photos, ok = 0;
    for (let i = 0; i < list.length; i++) {
      setProgress(`${i + 1}/${list.length} yükleniyor…`);
      const fd = new FormData(); fd.append("file", list[i]);
      try { const r = await api.http.post(`${api.base}/${lid}/photos`, fd); current = [...current, r.data]; onChange(current); ok++; }
      catch (err) { toast.error(`${list[i].name}: ${errText(err)}`); if (err?.response?.data?.detail?.includes("en fazla")) break; }
    }
    setProgress(null);
    if (ok) toast.success(`${ok} fotoğraf eklendi`);
  };
  const order = async (ids) => { try { const r = await api.http.put(`${api.base}/${lid}/photos/order`, { ids }); onChange(r.data); } catch (e) { toast.error(errText(e)); } };
  const move = (i, d) => { const ids = photos.map((p) => p.id); [ids[i], ids[i + d]] = [ids[i + d], ids[i]]; order(ids); };
  const cover = (i) => { const ids = photos.map((p) => p.id); order([ids[i], ...ids.filter((_, j) => j !== i)]); };
  const remove = async (p) => { if (!window.confirm("Fotoğraf silinsin mi?")) return; try { const r = await api.http.delete(`${api.base}/${lid}/photos/${p.id}`); onChange(r.data); } catch (e) { toast.error(errText(e)); } };
  if (!lid) return <p className="form-hint" data-testid="photos-locked">Fotoğraf eklemek için önce ilanı kaydedin.</p>;
  return (
    <div data-testid="photo-manager">
      <div className="lst-photos">
        {photos.map((p, i) => (
          <figure key={p.id} className={i === 0 ? "lst-photo cover" : "lst-photo"} data-testid={`photo-${i}`}>
            <img src={img(p.thumb)} alt="" />
            {i === 0 && <span className="lst-cover-badge"><Star size={11} />Kapak</span>}
            <figcaption>
              <button type="button" disabled={i === 0} onClick={() => move(i, -1)} title="Sola" data-testid={`photo-left-${i}`}><ArrowLeft size={13} /></button>
              <button type="button" disabled={i === photos.length - 1} onClick={() => move(i, 1)} title="Sağa" data-testid={`photo-right-${i}`}><ArrowRight size={13} /></button>
              {i > 0 && <button type="button" onClick={() => cover(i)} title="Kapak yap" data-testid={`photo-cover-${i}`}><Star size={13} /></button>}
              <button type="button" className="danger" disabled={locked && photos.length === 1} onClick={() => remove(p)} title="Sil" data-testid={`photo-delete-${i}`}><Trash2 size={13} /></button>
            </figcaption>
          </figure>
        ))}
        {photos.length < 30 && <label className="lst-photo add" data-testid="photo-upload-label">{progress ? <><Loader2 size={20} className="spin" /><small>{progress}</small></> : <><ImagePlus size={22} /><small>Fotoğraf ekle</small></>}
          <input type="file" hidden multiple accept="image/jpeg,image/png,image/webp" disabled={!!progress} onChange={upload} data-testid="photo-upload-input" /></label>}
      </div>
      <small className="form-hint">{photos.length}/30 fotoğraf · İlk fotoğraf kapak olur{api.member ? "" : " ve Instagram'da paylaşılır"}. Birden fazla fotoğrafı aynı anda seçebilirsiniz.</small>
    </div>
  );
}
